import {useCallback} from 'react';

import {PULLING_CREATE_TEEN} from '@/app/auth/events/PullingCreateTeenEvents';
import {PROJECT_TAGS} from '@/constants';
import {useTrackingManager} from '@/hooks';

export const useTrackers = (teenId: string) => {
  const {trackEvent} = useTrackingManager();

  const trackViewAddKidConfirmationSuccess = useCallback(() => {
    trackEvent(PULLING_CREATE_TEEN.VIEW_ADD_KID_CONFIRMATION_SUCCESS, {
      project_tag: PROJECT_TAGS.ONBOARDING,
      FamilyMember: {
        id: teenId,
      },
    });
  }, [teenId, trackEvent]);

  return {trackViewAddKidConfirmationSuccess};
};
